import {addToCartHandler} from "./addToCart";

const productBlocks = [...document.querySelectorAll('.js-product-block')];

productBlocks.map(productBlock => {
    const form = productBlock.querySelector('.js-product-block-form');

    if(form) {
        const submit = form.querySelector('.js-product-block-form-submit');

        const formClickHandler = (e) => {
            if(e.target !== submit && !submit.contains(e.target)) {
                e.preventDefault();
            }
        }

        form.addEventListener('click', formClickHandler);
        form.addEventListener('submit', addToCartHandler);
    }
});
